<template>
	<v-layout row wrap>
		<v-flex xs12 lg6 py-3 pl-1 pr-2>
			<v-card class="flex">
				<v-toolbar flat color="white">
					<v-toolbar-title class="grey--text text--darken-2">Carte Fedeltà</v-toolbar-title>
					<v-spacer></v-spacer>                                 
				</v-toolbar>
				<div id="fidelity-piechart"></div>
			</v-card>
		</v-flex>
		<v-flex xs12 lg6 py-3 pl-1 pr-2>
			<v-card class="flex">
				<v-toolbar flat color="white">
					<v-toolbar-title class="grey--text text--darken-2">Classifica Punti</v-toolbar-title>
					<v-spacer></v-spacer>                                 
				</v-toolbar>
				<div id="fidelity-categoryaxis"></div>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_material from '@amcharts/amcharts4/themes/material.js'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)
am4core.useTheme(am4themes_material)

export default {
	name: 'fidelitycards-chart',
	components: {},
	props: {},

	data() {
		return {
			fidelitycards: {},
			rankingpoints: {},
			chartFidelitycards: {},
			chartRankingPoints: {},
		}
	},

	mounted() {
		this.axios.get('dashboard').then(response => {
			// get body data
			this.fidelitycards = response.data.data.fidelitycards
			this.rankingpoints = response.data.data.ranking_points
			this.$store.commit('endProgress')

			let fidelitycardsChart = am4core.create('fidelity-piechart',
				am4charts.PieChart)
			fidelitycardsChart.hiddenState.properties.opacity = 0 // this creates initial fade-in

			fidelitycardsChart.data = this.fidelitycards

			fidelitycardsChart.radius = am4core.percent(70)
			fidelitycardsChart.innerRadius = am4core.percent(40)
			fidelitycardsChart.startAngle = 180
			fidelitycardsChart.endAngle = 360

			let series = fidelitycardsChart.series.push(new am4charts.PieSeries())
			series.dataFields.value = 'value'
			series.dataFields.category = 'type'

			series.slices.template.cornerRadius = 10
			series.slices.template.innerCornerRadius = 7
			series.slices.template.inert = true
			series.alignLabels = false

			series.hiddenState.properties.startAngle = 90
			series.hiddenState.properties.endAngle = 90

			fidelitycardsChart.legend = new am4charts.Legend()

			this.fidelitycardsChart = fidelitycardsChart
			// second

			// Create fidelitycardsChart instance
			let rankingpointsChart = am4core.create('fidelity-categoryaxis',
				am4charts.XYChart)


			// Add data
			rankingpointsChart.data = this.rankingpoints

			// Create axes
			let categoryAxis = rankingpointsChart.xAxes.push(new am4charts.CategoryAxis())
			categoryAxis.dataFields.category = 'customer'
			categoryAxis.renderer.grid.template.location = 0
			categoryAxis.renderer.minGridDistance = 30
			categoryAxis.renderer.labels.template.horizontalCenter = 'right'
			categoryAxis.renderer.labels.template.verticalCenter = 'middle'
			categoryAxis.renderer.labels.template.rotation = 270
			categoryAxis.tooltip.disabled = true
			categoryAxis.renderer.minHeight = 110

			let valueAxis = rankingpointsChart.yAxes.push(new am4charts.ValueAxis())
			valueAxis.renderer.minWidth = 50

			// Create series
			let series2 = rankingpointsChart.series.push(new am4charts.ColumnSeries())
			series2.sequencedInterpolation = true
			series2.dataFields.valueY = 'balance'
			series2.dataFields.categoryX = 'customer'
			series2.tooltipText = '[{categoryX}: bold]{valueY}[/]'
			series2.columns.template.strokeWidth = 0

			series2.tooltip.pointerOrientation = 'vertical'

			series2.columns.template.column.cornerRadiusTopLeft = 10
			series2.columns.template.column.cornerRadiusTopRight = 10
			series2.columns.template.column.fillOpacity = 0.8

			// on hover, make corner radiuses bigger
			let hoverState = series2.columns.template.column.states.create('hover')
			hoverState.properties.cornerRadiusTopLeft = 0
			hoverState.properties.cornerRadiusTopRight = 0
			hoverState.properties.fillOpacity = 1

			series2.columns.template.adapter.add('fill', (fill, target) => {
				return rankingpointsChart.colors.getIndex(target.dataItem.index)
			})

			// Cursor
			rankingpointsChart.cursor = new am4charts.XYCursor()

			this.rankingpointsChart = rankingpointsChart
		},
		response => {
			// error callback
		})
	},

	created() {},

	beforeDestroy() {
		if (this.fidelitycardsChart) {
			this.fidelitycardsChart.dispose()
		}
		if (this.rankingpointsChart) {
			this.rankingpointsChart.dispose()
		}
	},

	methods: {}
}
</script>

<style>
#fidelity-piechart,
#fidelity-categoryaxis {
  width: 100%;
  height: 500px;
}
</style>
